export interface IAktTag {
  id: string;
  value: string;
}

export default class AktTag implements IAktTag {
  public id!: string;
  public value!: string;
}
